//# sourceMappingURL=content_library.mjs.map
/// <reference types="./content_library.d.mts" />
import * as $data_source from "../../data_types/data/data_source.mjs";
import * as $checkbox from "../../ds/ds/components/checkbox.mjs";
import * as $label from "../../ds/ds/components/label.mjs";
import * as $l from "../../ds/ds/components/layout.mjs";
import * as $icons from "../../ds/ds/icons.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import * as $event from "../../redraw/redraw/event.mjs";
import * as $mouse from "../../redraw_dom/redraw/dom/event/mouse.mjs";
import * as $events from "../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../redraw_dom/redraw/dom/html.mjs";
import * as $msg from "../data/msg.mjs";
import * as $route from "../data/route.mjs";
import * as $store from "../data/store.mjs";
import { toList } from "../gleam.mjs";
import * as $data_sources from "../view/content_library/data_sources.mjs";
import * as $content_library from "../view/content_library/ingestion_control/content_library.mjs";
import * as $source from "../view/content_library/ingestion_control/data_source.mjs";
import * as $s from "../view/content_library/styles.mjs";

function content_library_menu() {
  return $redraw.component_(
    "IngestionControl(Menu)",
    (_) => {
      let store = $store.use_state();
      let dispatch = $store.use_dispatch();
      let dispatch$1 = (m) => { return dispatch(new $msg.ContentLibrary(m)); };
      let selected = store.content_library.selected;
      let selected_count = $dict.size(selected);
      let hidden = selected_count === 0;
      let content_library_count = $list.length(
        store.content_library.non_qna_sources.all,
      );
      let all_selected = content_library_count === selected_count;
      let _block;
      if (all_selected) {
        _block = new $checkbox.Checked();
      } else if (hidden) {
        _block = new $checkbox.Unchecked();
      } else {
        _block = new $checkbox.Indeterminate();
      }
      let check_state = _block;
      return $s.menu_wrapper(
        hidden,
        toList([]),
        toList([
          $s.menu(
            toList([]),
            toList([
              $l.row(
                toList([$l.gap(16)]),
                toList([]),
                toList([
                  $checkbox.checkbox(
                    check_state,
                    false,
                    (_) => {
                      let _pipe = new $msg.UserClickedGlobalCheckbox(
                        all_selected,
                        store.content_library.non_qna_sources.all,
                      );
                      dispatch$1(_pipe);
                      return undefined;
                    },
                  ),
                  $s.number_selected(
                    toList([]),
                    toList([
                      $h.text($int.to_string(selected_count) + " selected"),
                    ]),
                  ),
                ]),
              ),
              $s.change_button(
                toList([
                  $events.on_click(
                    (event) => {
                      let _pipe = event;
                      let _pipe$1 = $mouse.as_event(_pipe);
                      let _pipe$2 = $event.prevent_default(_pipe$1);
                      $event.stop_propagation(_pipe$2);
                      dispatch$1(new $msg.UserToggledChangeStatusPopup());
                      return undefined;
                    },
                  ),
                ]),
                toList([
                  $s.change_icon(false, $icons.checkmark()),
                  $h.text("Change status"),
                  $s.change_icon(
                    !store.content_library.change_status_popup_opened,
                    $icons.arrow_dropdown(),
                  ),
                  (() => {
                    let $ = store.content_library.change_status_popup_opened;
                    if ($) {
                      return $s.change_status_popup(
                        toList([]),
                        toList([
                          $label.label(
                            toList([
                              $label.success(),
                              $label.content("Verified"),
                              $label.on_click(
                                () => {
                                  dispatch$1(
                                    new $msg.UserAssignedStatus(
                                      new $data_source.Verified(),
                                    ),
                                  );
                                  return undefined;
                                },
                              ),
                            ]),
                          ),
                          $label.label(
                            toList([
                              $label.current(),
                              $label.content("Pending"),
                              $label.on_click(
                                () => {
                                  dispatch$1(
                                    new $msg.UserAssignedStatus(
                                      new $data_source.Pending(),
                                    ),
                                  );
                                  return undefined;
                                },
                              ),
                            ]),
                          ),
                          $label.label(
                            toList([
                              $label.neutral(),
                              $label.content("Not verified"),
                              $label.on_click(
                                () => {
                                  dispatch$1(
                                    new $msg.UserAssignedStatus(
                                      new $data_source.NotVerified(),
                                    ),
                                  );
                                  return undefined;
                                },
                              ),
                            ]),
                          ),
                          $label.label(
                            toList([
                              $label.error(),
                              $label.content("Outdated"),
                              $label.on_click(
                                () => {
                                  dispatch$1(
                                    new $msg.UserAssignedStatus(
                                      new $data_source.Outdated(),
                                    ),
                                  );
                                  return undefined;
                                },
                              ),
                            ]),
                          ),
                        ]),
                      );
                    } else {
                      return $h.none();
                    }
                  })(),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    $data_sources.view(),
    (data_sources) => {
      return $redraw.compose(
        $content_library.view(),
        (content_library) => {
          return $redraw.compose(
            $source.view(),
            (data_source) => {
              return $redraw.compose(
                content_library_menu(),
                (content_library_menu) => {
                  return $redraw.component_(
                    "ContentLibrary",
                    (_use0) => {
                      let route = _use0[0];
                      if (route instanceof $route.DataSources) {
                        let page = route.page;
                        return data_sources([page]);
                      } else {
                        let route$1 = route[0];
                        return $redraw.fragment(
                          toList([
                            (() => {
                              if (route$1 instanceof $route.Controls) {
                                return content_library(undefined);
                              } else {
                                let source_id = route$1.source_id;
                                return data_source([source_id]);
                              }
                            })(),
                            content_library_menu(undefined),
                          ]),
                        );
                      }
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
